import React, { Component } from 'react';

// Spinner icon

const Spinner = () => {
    return (
        < div className= "ball-pulse" >
            <div></div>
            <div></div>
            <div></div>
        </div >
    )
}

export default Spinner;


// WEBPACK FOOTER //
// ./master/jsx/components/Widgets/spinner.jsx